import { PaintedScene } from '../PaintedScene';

export const SNOW_FIELD_PHASER_KEY = 'SnowFieldScene' as const;
export const SNOW_FIELD_MANIFEST_KEY = 's-311-snow-field' as const;

export class SnowFieldScene extends PaintedScene {
  constructor() {
    super(SNOW_FIELD_PHASER_KEY, SNOW_FIELD_MANIFEST_KEY);
  }
}
